import script from "./Login.vue?vue&type=script&setup=true&lang=js"
export * from "./Login.vue?vue&type=script&setup=true&lang=js"

import "./Login.vue?vue&type=style&index=0&id=2f5e95ea&lang=scss&scoped=true"

import exportComponent from "D:\\psy\\项目\\guofang\\oldgfzs\\home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f5e95ea"]])

export default __exports__